import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DwSecurityOrchestrationService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { SentryErrorHandler } from '@sentry/angular';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { ConfigService } from 'src/environments/environment';
import * as Sentry from "@sentry/angular";
import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from 'rxjs/operators';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, HttpInterceptor {
  showLayout = true;
  environmentMessage: string;
  themeClasses: string;
  minimizeSidebar: boolean = false;
  missingTrustUserIdMessage = '';

  constructor(private securityService: DwSecurityUserService, public router: Router,
    private securityOrchestratinService: DwSecurityOrchestrationService
    ) {


  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-17934420-8',
          {
            'page_path': event.urlAfterRedirects
          }
        );
      }
      this.setupTheme();
    });

    this.securityService.securityContextChanged().subscribe(context => {
      this.setupSecurity();
      this.setupTheme();
    })
    this.environmentMessage = ConfigService.config?.environmentMessage;

    this.setupTheme();
  }

  private setupSecurity() {
    this.missingTrustUserIdMessage = '';
    if (this.securityService.securityState.isAuthenticated) {

      const wachterAuthUser = new WachterUserExt(this.securityService.securityContext.AuthenticatedUser);
      const wachterAppUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);

      var wachterUserId = wachterAuthUser.trustUserId;
      var wachterEmail = wachterAuthUser.user.Email;

      if (!wachterAppUser.trustUserId) {
        this.missingTrustUserIdMessage = `User ${wachterAppUser.user.FirstNameLastName} is not assigned a Trust User Id!`;
      }

      Sentry.setUser({ email: wachterEmail, id: wachterUserId?.toString() });
      gtag('set', { 'user_id': wachterUserId });
      gtag('set', 'dimension1', wachterUserId);
      gtag('set',
        {
          'custom_map':
          {
            'dimension1': wachterUserId
          }
        });
       
    } 

    
  }

  setupTheme() {
    if (this.securityOrchestratinService.skipAutoSSOLogin() && !this.securityService.securityState.isAuthenticated) {
      this.themeClasses = 'home-theme';
    } else {
      this.themeClasses = '';
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error) => {
        Sentry.captureEvent(error);
        // return throwError(error.message);
        return throwError(error);
      })
    )
  }

}
